function initializeSwiper() {
  const screenWidth = window.innerWidth;
  const swiperContainer = document.querySelector('.trust-indicator-swiper-active');
  const swiperWrapper = swiperContainer.querySelector('.trust__indicators-container');
  const swiperBoxes = swiperContainer.querySelectorAll('.trust__indicators-box');
  const swiperPagination = swiperContainer.querySelector('.trust__indicators-pagination');

  if (screenWidth < 990 && !swiperContainer.swiperInstance) {
    swiperContainer.classList.add('swiper');
    swiperWrapper.classList.add('swiper-wrapper');
    swiperBoxes.forEach(box => {
      box.classList.add('swiper-slide');
    });

    swiperContainer.swiperInstance = new Swiper(swiperContainer, {
      slidesPerView: 1,
      pagination: {
        el: swiperPagination,
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  } else if (screenWidth >= 990 && swiperContainer.swiperInstance) {
    swiperContainer.swiperInstance.destroy(true, true);
    swiperContainer.swiperInstance = null;

    swiperContainer.classList.remove('swiper');
    swiperWrapper.classList.remove('swiper-wrapper');
    swiperBoxes.forEach(box => {
      box.classList.remove('swiper-slide');
    });
  }
}

window.addEventListener('load', initializeSwiper);
window.addEventListener('resize', () => {
  setTimeout(initializeSwiper, 300); 
});
